import React, { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from 'react';

import { cn } from 'lib/helpers/utility';

import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';
import Dot from 'components/shared/Dot/Dot';

const CurrencyCellEditorInner = (params, ref) => {
  const {
    style,
    disabled,
    maxValue,
    validationMessages,
    className,
    parentClassName,
    initialValue,
    value,
    dot
  } = params || {};
  const [inputValue, setInputValue] = useState(initialValue ?? value ?? 0);
  const refCurrencyInput = useRef(null);

  useEffect(() => {
    refCurrencyInput.current?.focus?.();
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      getValue: () => inputValue
    }),
    [inputValue]
  );

  return (
    <div
      tabIndex={1}
      className={cn('flex items-center gap-2.5', !dot && 'px-2.5', parentClassName)}>
      {dot && <Dot color="success" size="sm" />}
      <CurrencyInput
        ref={refCurrencyInput}
        style={style}
        variant="secondary"
        wrapperClassName="h-[37px] !rounded-none !p-0 mt-0.5"
        hideBorder
        value={inputValue}
        maxValue={maxValue}
        validationMessages={validationMessages}
        className={className}
        onValueChange={setInputValue}
        disabled={disabled}
      />
    </div>
  );
};

const CurrencyCellEditor = memo(forwardRef(CurrencyCellEditorInner));
export default CurrencyCellEditor;
